import { DetectedFile } from "../../types";

import { CSVTable } from "./CSVTable";

interface TextPreviewProps {
  text: string;
  detectedFile: DetectedFile;
}

export const TextPreview = ({ text, detectedFile }: TextPreviewProps) => {
  const isJson = detectedFile.type === "json";
  const isCsv = detectedFile.type === "csv";

  const getContentTypeLabel = (): string => {
    if (isJson) {
      return "JSON Content";
    }

    if (isCsv) {
      return "CSV Content";
    }

    return "Text Content";
  };

  return (
    <div className="space-y-1">
      <div className="text-sm font-medium">{getContentTypeLabel()}</div>
      {isCsv ? (
        <CSVTable csvString={text} />
      ) : (
        <pre className="max-h-[55vh] overflow-y-auto whitespace-pre-wrap break-words text-xs">
          {text}
        </pre>
      )}
    </div>
  );
};
